module.exports = __webpack_public_path__ + "static/media/night_view_gate.a149cf9b.jpg";